import React, { useContext, useMemo, useState } from "react";

//customHook
import useMinimizar from '../../customHooks/useMinimizar';

import './ConsumosList.css'; 

import ModalForm from "../modalForm/ModalForm";
import RRConsumo from "../renderRows/RRConsumo";
import ConsumoInfo from "../consumoInfo/ConsumoInfo";
import consumosContext from "../../context/consumosContext/consumosContext";
import normalizeText from "../../utils/normalizeText";

const ConsumosList = ({consumos,filter,getProductsByNroFor,usuario}) =>{

    const [showInfo,setShowInfo] = useState(null);
    const [selected,setSelected] = useState("");

    const {generarInformeReqPDF} = useContext(consumosContext);

    const handlerDetails = async (item) => {
        setSelected(null);
        if(item){
            setSelected(item);
        }
    }

    const handlerGenerarPDF = async (tDocCodFor = 'CONS', tDocNroFor) => {
        generarInformeReqPDF({tDocCodFor,tDocNroFor},usuario);
    }

    const handlerVerReqDetails = async (tDocCodFor, tDocNroFor) => {
        return await getProductsByNroFor(tDocCodFor, tDocNroFor);
    }

    const consumosFiltered = useMemo(()=> consumos.filter(c => {
        return filter != '' ?
            (filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ?
                (normalizeText(`${c.tDocCodFor} - ${c.tDocNroFor}`) == normalizeText(filter.replaceAll('"','')) || normalizeText(c.title) == normalizeText(filter.replaceAll('"','')) || normalizeText(c.tDocNroFor.toString()) == normalizeText(filter.replaceAll('"','')))
            :
                (normalizeText(`${c.tDocCodFor} - ${c.tDocNroFor}`).includes(normalizeText(filter)) || normalizeText(c.title).includes(normalizeText(filter)) || normalizeText(c.tDocNroFor.toString()).includes(normalizeText(filter)))
        : true; 
        })
    ,[consumos, filter])

    return <div className={`consumosListDiv`} >
        {(consumos != undefined && consumos.length > 0) ? consumosFiltered.map((consumo, i) => <RRConsumo key={`${consumo.codActivo}-${i}`} consumo={consumo} index={i} setShowInfo={setShowInfo} verDetalles={handlerDetails}/>) : <div className="consumoDiv">
            <h4>No hay consumos para mostrar</h4>
        </div>}
        {selected && <div className="modalContainer">
                <ConsumoInfo item={selected} files={selected.files} cerrar={handlerDetails} verDetalle={handlerVerReqDetails} repetir={()=>console.log("repeat")} generaPDF={handlerGenerarPDF} abrirURL={()=>console.log("handlerAbrirURL")} guardarModificaciones={()=>console.log("modificarEstado")} usuario={usuario}/>
            </div>
        } 
    </div>

}

export default ConsumosList;